import { Button, Icon, Link, Dropdown } from '@monash/portal-react';
import {
  RenderAnimation,
  getCategoryIllustration,
} from '@monash/portal-frontend-common';
import React, { useContext, useState, useEffect } from 'react';
import PageContainer from '../../layouts/page-container/PageContainer';
import { PopularLinks } from './components/PopularLinks';
import { Subcategory } from './components/Subcategory';
import { SearchContext } from '../../providers/search-provider/SearchProvider';
import { formatSubcategories } from './utils/format-subcategories';
import { getDropdownFilterList } from './utils/get-dropdown-filter-list';
import { getAvailableFilters } from './utils/get-available-filters';
import { linkMatchesFilters } from './utils/link-matches-filters';
import c from './category-new.module.scss';

const Category = ({ category: currentCategory, heroIndex }) => {
  const { allLinks, allCategories } = useContext(SearchContext);

  const links = allLinks
    .map((link) => link.entityContent)
    .filter((link) =>
      link.categories?.find((category) => category.id === currentCategory.id)
    );
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [heroLottie, setHeroLottie] = useState(null);

  useEffect(() => {
    getCategoryIllustration(currentCategory.illustration).then((lottie) =>
      setHeroLottie(lottie)
    );
  }, []);

  // Apply selected filters to links
  const filteredLinks =
    selectedFilters.length > 0
      ? links.filter((link) => linkMatchesFilters(link, selectedFilters))
      : links;

  const formattedSubcategories = formatSubcategories({
    category: currentCategory,
    links: filteredLinks,
  });

  const availableFilters = getAvailableFilters(links);

  const dropdownFilters = getDropdownFilterList(availableFilters);

  return (
    <PageContainer type="default">
      <Link to="/" className={c.backNavigation} tabIndex="-1">
        <Button size="small" variant="text" icon={<Icon.ChevronLeft />}>
          Back
        </Button>
      </Link>
      <div className={c.content}>
        <div className={c.banner}>
          <div className={c.header}>
            <h1 data-testid="category-title">{currentCategory.title}</h1>
            <p>{currentCategory.description}</p>
          </div>
          <RenderAnimation className={c.heroMedia} lottieFile={heroLottie} />
        </div>

        <PopularLinks
          links={filteredLinks}
          categoryId={currentCategory.id}
          allCategories={allCategories}
        />

        {/* Subcategories */}
        <div className={c.wrapper}>
          <div className={c.contentSection}>
            <h2 className={c.heading}>Subcategories</h2>

            {formattedSubcategories.map((subcategory) => {
              const hasLinks = Boolean(subcategory.links?.length);

              return (
                hasLinks && (
                  <Subcategory
                    subcategoryName={subcategory.title}
                    links={subcategory.links}
                    allCategories={allCategories}
                    key={subcategory.title}
                  />
                )
              );
            })}
          </div>

          <div className={c.filterWrapper}>
            <div className={c.filter}>
              Filter:
              <Dropdown
                id="type"
                className="custom-class"
                ariaLabelledby="type"
                onChange={(newFilters) => {
                  setSelectedFilters(newFilters);
                }}
                value={selectedFilters}
                data={dropdownFilters}
                multi
              />
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default Category;
